export const rendererPageIdsWithoutEntityId = [
  "root",
  "intro",
  "outro",
  "theme",
  "theme-settings",
  "music",
  "branding",
  "clips",
  "confirm",
] as const;

export type RendererPageIdWithoutEntityId =
  (typeof rendererPageIdsWithoutEntityId)[number];

export const rendererPageIdsWithEntityId = [
  "clip-rotate",
  "clip-music",
  "edit-photo",
  "photo-duration",
  "photo-caption",
  "edit-video",
  "video-trim",
] as const;

export type RendererPageIdWithEntityId =
  (typeof rendererPageIdsWithEntityId)[number];

export const rendererPageIds = [
  ...rendererPageIdsWithoutEntityId,
  ...rendererPageIdsWithEntityId,
] as const;

export type RendererPageId = (typeof rendererPageIds)[number];

export function getIsRendererPageId(
  pageId: string | undefined
): pageId is RendererPageId {
  if (!pageId) {
    return false;
  } else {
    return rendererPageIds.includes(pageId as RendererPageId);
  }
}

export function getRenderPageRequiresEntityId(
  pageId: string
): pageId is RendererPageIdWithEntityId {
  return rendererPageIdsWithEntityId.includes(
    pageId as RendererPageIdWithEntityId
  );
}

export type RendererPageInfo =
  | {
      pageId: RendererPageIdWithoutEntityId;
    }
  | {
      pageId: RendererPageIdWithEntityId;
      /** If this is e.g. an edit page, entityId will be the id of the entity being
edited (e.g. a clip's segmentId) **/
      entityId: string;
    };

export const photoClipDurations = [3, 5, 10] as const;
export const defaultPhotoClipDurationSeconds: ClipDuration = 5;
export type ClipDuration = (typeof photoClipDurations)[number];
